import { Outlet } from 'react-router';

const AuthLayout = () => (
  <main className="min-h-screen bg-gradient-to-br from-brand-navy to-brand-vivid flex items-center justify-center p-6">
    <div className="w-full max-w-sm rounded-xl bg-bg-surface p-8 shadow-lg">
      <div className="mb-5 flex items-center justify-center gap-2">
        <img alt="Lidz" className="size-30 shrink-0" src="/logo-login-navy.svg" />
      </div>
      <Outlet />
    </div>
  </main>
);

export default AuthLayout;
